import { memo, useEffect, useState } from 'react'

import CustomPopover, { CustomPopoverProps } from '@components/CustomPopover'
import { Dialog, DialogContent } from '@mui/material'
import { useScreenDimensions } from '@shared/hooks/useScreenDimensions'

import AddNewShortlistSection, { AddNewShortlistSectionProps } from '.'
import { PopoverInner } from '../ShortlistProfileButton/index.styles'

const AddNewShortlistSectionPopover = (props: AddNewShortlistSectionProps & { anchor: CustomPopoverProps['anchor'] }) => {
  const { anchor, shortlists, isUniqueName, onCancel, onSuccess } = props
  const { isDesktop } = useScreenDimensions()

  const [editedValue, setEditedValue] = useState('')

  useEffect(() => {
    setEditedValue('')
  }, [anchor])

  if (!isDesktop) {
    return (
      <Dialog open={Boolean(anchor)} onClose={() => onCancel(editedValue)} fullWidth maxWidth="xs">
        <DialogContent>
          <AddNewShortlistSection
            isUniqueName={isUniqueName}
            shortlists={shortlists}
            onCancel={onCancel}
            onSuccess={onSuccess}
            onChange={setEditedValue}
          />
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <CustomPopover id="shortlist_popover" anchor={anchor} setAnchor={() => onCancel(editedValue)}>
      <PopoverInner width={270}>
        <AddNewShortlistSection
          isUniqueName={isUniqueName}
          shortlists={shortlists}
          onCancel={onCancel}
          onSuccess={onSuccess}
          onChange={setEditedValue}
        />
      </PopoverInner>
    </CustomPopover>
  )
}

export default memo(AddNewShortlistSectionPopover)
